import React, { useMemo } from "react";
import { useGroupChatContext } from "../../context/groupchatContext";
import GlobalDocuments from "./globalDocuments";

function GlobalDocumentsPage() {
  const groupChatContext = useGroupChatContext();

  const { setShowGlobalDocuments, authData } = useMemo(
    () => ({
      setShowGlobalDocuments: groupChatContext.setShowGlobalDocuments,
      authData: groupChatContext.authData,
    }),
    [groupChatContext]
  );

  const handleGoBack = () => {
    setShowGlobalDocuments(false);
  };

  return (
    <div className="flex flex-col h-full min-h-0 overflow-hidden bg-gray-50/50">
      <header
        className={`flex items-center justify-between shrink-0 ${
          authData?.is_provider ? "bg-ethizo_primary" : "bg-bg-primary"
        } flex-row px-4 sm:px-6 py-3 sm:py-4 h-14 sm:h-16 text-white shadow-sm`}
      >
        <h1 className="text-lg sm:text-xl font-semibold truncate">Documents</h1>
        <button
          onClick={handleGoBack}
          title="Go Back to Home"
          aria-label="Go Back to Home"
          className="font-medium py-2 px-3 sm:px-4 rounded-lg hover:bg-white/15 active:scale-[0.98] transition-all text-sm sm:text-base shrink-0"
        >
          Back to Home
        </button>
      </header>

      <main className="flex-1 min-w-0 overflow-y-auto overflow-x-hidden bg-gray-50/50">
        <GlobalDocuments />
      </main>
    </div>
  );
}

export default GlobalDocumentsPage;
